module.exports = __webpack_public_path__ + "img/music_1.d56083a8.png";